import { FC, ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";

interface MenuGroupComponentProps {
  name: string;
  children: ReactNode;
}

const MenuGroupComponent: FC<MenuGroupComponentProps> = ({
  name,
  children,
}) => {
  return (
    <Flex flexDirection="column" w="100%">
      <Text fontSize="xs" textTransform="uppercase" mb={2} pl={2}>
        {name}
      </Text>
      <Flex flexDirection="column" alignItems="center">
        {children}
      </Flex>
    </Flex>
  );
};

export default MenuGroupComponent;
